<template>
  <ContentWrapper>
    <v-card tile>
      <v-card-title>Impressum ETC Ellerau</v-card-title>
      <v-card-text>
        <p>
          <b>Verantwortlich für den Inhalt:</b> <br/> Ellerauer Tennis Club an der Krumbek e.V.
          Anschrift: Königsberger Str. 16, 25479 Ellerau<br/>
          E-Mail: <a href="mailto:etc.krumbek@etc-ellerau.de">etc.krumbek@etc-ellerau.de</a><br/>
          Internet: www.etc-ellerau.de<br/>
        </p>

        <p>
          <b>Präsidium:</b> <br/>(Lt. Satzung sind je 2 Präsidiumsmitglieder vertretungsberechtigt)<br/>
          Axel Xaver Neigenfink, Vorsitzender<br/>
          Ulrike Lentzsch, 2. Vorsitzende<br/>
          Matthias Kolb, Finanzen<br/>
          Carsten Walter, Sportwart<br/>
          Pauline Seidel, Jugendwärtin<br/>
          Jens Kuchenbecker, Liegenschaftswart<br/>
          Anschrift: s. o.<br/><br/>
        </p>

        <p>
          <b>Vereinsregister:</b><br/>
          Anschrift: Amtsgericht Norderstedt, Rathausallee 80, 22486 Norderstedt<br/>
          Registernummer: VR Nr. 192<br/>
          <br/>
        </p>

        <p>
          <b>Geschäftsstelle:</b><br/>
          Anna Tkatsch<br/>
          Anschrift: Moortwiete 5a, 25479 Ellerau<br/>
          Telefon: 0155/60826751<br/>
          E-Mail: <a href="mailto:gs@etc-ellerau.de">Geschäftsstelle</a><br/>
          Sprechzeiten: <b>Donnerstag 13:00-18:00 Uhr</b><br/><br/>
          Bitte kontaktieren Sie die Geschäftsstelle außerhalb dieser Zeiten per WhatsApp oder SMS unter der o.g.
            Nummer<br/>
        </p>

        <p>
          <b>Webmaster:</b><br/>
          Sönke Wunderlich<br/>
          Anschrift: Lerchenweg 22a, 25451 Quickborn<br/>
          Telefon: 04106/6409461<br/>
          E-Mail: <a href="mailto:webmaster@etc-ellerau.de">Webmaster</a><br/>
          <br/>
        </p>

        <p>
          <b>1. Haftungsbeschränkung</b><br/>
          Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt erstellt. Der Anbieter
          übernimmt jedoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der
          bereitgestellten Inhalte. Die Nutzung der Inhalte der Website erfolgt auf eigene Gefahr des
          Nutzers.
          Namentlich gekennzeichnete Beiträge geben die Meinung des jeweiligen Autors und nicht immer
          die Meinung des Anbieters wieder. Mit der reinen Nutzung der Website des Anbieters kommt
          keinerlei Vertragsverhältnis zwischen dem Nutzer und dem Anbieter zustande.<br/><br/>

          <b>2. Externe Links</b><br/>
          Diese Website enthält Verknüpfungen zu Websites Dritter ("externe Links"). Diese Websites
          unterliegen der Haftung der jeweiligen Betreiber. Der Anbieter hat bei der erstmaligen
          Verknüpfung der externen Links die fremden Inhalte daraufhin überprüft, ob etwaige
          Rechtsverstöße bestehen. Zu dem Zeitpunkt waren keine Rechtsverstöße ersichtlich. Der
          Anbieter hat keinerlei Einfluss auf die aktuelle und zukünftige Gestaltung und auf die
          Inhalte der verknüpften Seiten. Das Setzen von externen Links bedeutet nicht, dass sich der
          Anbieter die hinter dem Verweis oder Link liegenden Inhalte zu Eigen macht. Eine ständige
          Kontrolle der externen Links ist für den Anbieter ohne konkrete Hinweise auf Rechtsverstöße
          nicht zumutbar. Bei Kenntnis von Rechtsverstößen werden jedoch derartige externe Links
          unverzüglich gelöscht.<br/><br/>

          <b>3. Urheber- und Leistungsschutzrechte</b><br/>
          Die auf dieser Website veröffentlichten Inhalte unterliegen dem deutschen Urheber- und
          Leistungsschutzrecht. Jede vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene
          Verwertung bedarf der vorherigen schriftlichen Zustimmung des Anbieters oder jeweiligen
          Rechteinhabers. Dies gilt insbesondere für Vervielfältigung, Bearbeitung, Übersetzung,
          Einspeicherung, Verarbeitung bzw. Wiedergabe von Inhalten in Datenbanken oder anderen
          elektronischen Medien und Systemen. Inhalte und Rechte Dritter sind dabei als solche
          gekennzeichnet. Die unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte oder
          kompletter Seiten ist nicht gestattet und strafbar. Lediglich die Herstellung von Kopien und
          Downloads für den persönlichen, privaten und nicht kommerziellen Gebrauch ist erlaubt. Die
          Darstellung dieser Website in fremden Frames ist nur mit schriftlicher Erlaubnis zulässig.<br/>
        </p>
      </v-card-text>
    </v-card>
  </ContentWrapper>
</template>
<script>
import ContentWrapper from "../components/ContentWrapper";

export default {
  components: {
    ContentWrapper
  },
  mounted() {
    this.$store.commit('SET_TITLE', 'Impressum')
  }
}
</script>
